/**
 * Types of organization configuration documents.
 */
export enum OrgConfigName {
  operator = 'operator',
}
